import React, { useState, useEffect, useRef, useContext} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';
import OrderCard from 'components/OrderCard';
import SoftBox from 'components/SoftBox';
import SoftButton from 'components/SoftButton';
import { Tabs, Tab, Card, IconButton } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import DataTable from 'prefabsComponents/Tables/DataTable';
import axios from 'axios';
import Swal from 'sweetalert2';

import { AuthContext } from 'context/AuthContext';

// Función para obtener datos de Trafico Cabecera
import fetchTrafficCabeceraData from './data/fetchTrafficCabeceraData';
// Función para obtener datos de Trafico Detalle (actualizada para recibir callbacks)
import fetchTrafficDetalleData from './data/fetchTrafficDetalleData';

// Importamos los modales
import ModalTrafficHeader from './components/ModalTrafficHeader';
import ModalTrafficDetails from './components/ModalTrafficDetails';

function OrderTrafficsShipment() {
  const navigate = useNavigate();
  const { numeroOrdenDetalle } = useParams();

  const [orderInfo, setOrderInfo] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [table, setTable] = useState({ columns: [], rows: [] });
  const currentPageData = useRef(null);

  // Estados para controlar los modales
  const [showCabeceraModal, setShowCabeceraModal] = useState(false);
  const [cabeceraModalData, setCabeceraModalData] = useState(null);
  const [showDetalleModal, setShowDetalleModal] = useState(false);
  const [detalleModalData, setDetalleModalData] = useState(null);

  // 🔒 Roles
  const { hasRole } = useContext(AuthContext);
  const canAddShipments = hasRole('admin', 'user'); // los clientes no pueden agregar

  // Función que recarga la data de Trafico Cabecera
  const fetchTraficosCabecera = async () => {
    try {
      const data = await fetchTrafficCabeceraData(
        numeroOrdenDetalle,
        handleEditTrafficHeader,
        handleDeleteTrafficHeader
      );
      setTable(data);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron cargar los datos de tráfico cabecera.'
      });
    }
  };

  // Función que recarga la data de Trafico Detalle
  const fetchTraficosDetalle = async () => {
    try {
      const data = await fetchTrafficDetalleData(
        numeroOrdenDetalle,
        handleEditTrafficDetail,
        handleDeleteTrafficDetail
      );
      setTable(data);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron cargar los datos de tráfico detalle.'
      });
    }
  };

  // Función para editar tráfico cabecera
  const handleEditTrafficHeader = (item) => {
    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/api/orders/traffic-header-info/`, {
        params: { id: item.id_trafico }
      })
      .then(response => {
        const data = Array.isArray(response.data) ? response.data[0] : response.data;
        console.log("Datos obtenidos para editar (cabecera):", data);
        setCabeceraModalData(data);
        setShowCabeceraModal(true);
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron obtener los datos del tráfico para editar.'
        });
        console.error("Error fetching traffic header info:", error);
      });
  };

  // Función para eliminar tráfico cabecera
  const handleDeleteTrafficHeader = (item) => {
    Swal.fire({
      icon: 'warning',
      title: '¿Eliminar?',
      text: '¿Está seguro de eliminar este tráfico?',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        axios
          .delete(`${process.env.REACT_APP_SERVER_URL}/api/orders/traffic-header/`, {
            data: { id: item.id_trafico }
          })
          .then(response => {
            Swal.fire({
              icon: 'success',
              title: 'Eliminado',
              text: 'El tráfico ha sido eliminado con éxito!'
            });
            if (tabValue === 0) fetchTraficosCabecera();
          })
          .catch(error => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Error eliminando tráfico. Inténtelo nuevamente.'
            });
            console.error("Error eliminando tráfico:", error);
          });
      }
    });
  };

  // Función para editar detalle de tráfico
  const handleEditTrafficDetail = (item) => {
    axios
      .get(`${process.env.REACT_APP_SERVER_URL}/api/orders/traffic-details-info/`, {
        params: { id: item.id_trafico_detalle }
      })
      .then(response => {
        const data = Array.isArray(response.data) ? response.data[0] : response.data;
        console.log("Datos obtenidos para editar (detalle):", data);
        setDetalleModalData(data);
        setShowDetalleModal(true);
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron obtener los datos del detalle de tráfico para editar.'
        });
        console.error("Error fetching traffic details info:", error);
      });
  };

  // Función para eliminar detalle de tráfico
  const handleDeleteTrafficDetail = (item) => {
    Swal.fire({
      icon: 'warning',
      title: '¿Eliminar?',
      text: '¿Está seguro de eliminar este detalle de tráfico?',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        axios
          .delete(`${process.env.REACT_APP_SERVER_URL}/api/orders/traffic-details/`, {
            data: { id: item.id_trafico_detalle }
          })
          .then(response => {
            Swal.fire({
              icon: 'success',
              title: 'Eliminado',
              text: 'El detalle de tráfico ha sido eliminado con éxito!'
            });
            // Recargar la data del datatable sin recargar la página
            if (tabValue === 1) fetchTraficosDetalle();
          })
          .catch(error => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Error eliminando detalle de tráfico. Inténtelo nuevamente.'
            });
            console.error("Error eliminando tráfico detalle:", error);
          });
      }
    });
  };

  // Simulación de obtención de información de la orden.
  useEffect(() => {
    const dummyOrderInfo = {
      cliente: "Cliente Demo",
      fecha: "2025-02-20",
      entrega: "2025-02-25",
      real_entrega: "2025-02-26",
      responsable: "Responsable Demo",
      proveedor: "Proveedor Demo",
      incoterms: "FOB",
      transporte: "Aéreo",
      origen: "Origen Demo",
      status: "Pendiente",
      numero: numeroOrdenDetalle || "12345",
    };
    setOrderInfo(dummyOrderInfo);
  }, [numeroOrdenDetalle]);

  const orderCardInfo = orderInfo
    ? {
        cliente: orderInfo.cliente,
        'Fecha de Embarque': orderInfo.fecha,
        'Fecha de Arribo': orderInfo.entrega,
        'Fecha Real de Arribo': orderInfo.real_entrega,
        responsable: orderInfo.responsable,
        proveedor: orderInfo.proveedor,
        incoterms: orderInfo.incoterms,
        transporte: orderInfo.transporte,
        origen: orderInfo.origen,
        status: orderInfo.status,
      }
    : {};

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (tabValue === 0) {
      fetchTraficosCabecera();
    } else if (tabValue === 1) {
      fetchTraficosDetalle();
    }
  }, [tabValue, numeroOrdenDetalle]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mb={2} display="flex" flexDirection="column" alignItems="flex-end">
        <IconButton
          aria-label="back"
          onClick={() => navigate(-1)}
          style={{ padding: '4px', fontSize: '1.275rem' }}
        >
          <ArrowBackIosNewIcon fontSize="small" style={{ marginRight: '4px' }} />
          Regresar
        </IconButton>
      </SoftBox>
      <SoftBox my={3}>
        <OrderCard numero={orderInfo ? `#${orderInfo.numero}` : ''} info={orderCardInfo} />
        <SoftBox mt={4}>
          <Card>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label="Trafico Cabecera" />
              <Tab label="Detalle Trafico" />
            </Tabs>
            {tabValue === 0 && (
              <SoftBox p={2}>
                {canAddShipments && (
                  <SoftButton
                    variant="gradient"
                    color="info"
                    style={{ marginBottom: '8px' }}
                    onClick={() => {
                      setCabeceraModalData(null); // Modo agregar
                      setShowCabeceraModal(true);
                    }}
                  >
                    Agregar Traficos
                  </SoftButton>
                )}
                <DataTable
                  onPageData={(data) => {
                    currentPageData.current = data;
                  }}
                  canSearch
                  entriesPerPage
                  showTotalEntries
                  table={table}
                />
              </SoftBox>
            )}
            {tabValue === 1 && (
              <SoftBox p={2}>
                {canAddShipments && (
                  <SoftButton
                    variant="gradient"
                    color="info"
                    style={{ marginBottom: '8px' }}
                    onClick={() => {
                      setDetalleModalData(null); // Modo agregar
                      setShowDetalleModal(true);
                    }}
                  >
                    Agregar Detalles
                  </SoftButton>
                )}
                <DataTable
                  onPageData={(data) => {
                    currentPageData.current = data;
                  }}
                  canSearch
                  entriesPerPage
                  showTotalEntries
                  table={table}
                />
              </SoftBox>
            )}
          </Card>
        </SoftBox>
      </SoftBox>
      <Footer />
      {/* Modal para Trafico Cabecera */}
      <ModalTrafficHeader
        show={showCabeceraModal}
        handleClose={() => {
          setShowCabeceraModal(false);
          fetchTraficosCabecera();
        }}
        initialData={cabeceraModalData}
      />
      {/* Modal para Detalle Trafico */}
      <ModalTrafficDetails
        show={showDetalleModal}
        handleClose={() => {
          setShowDetalleModal(false);
          fetchTraficosDetalle();
        }}
        initialData={detalleModalData}
      />
    </DashboardLayout>
  );
}

export default OrderTrafficsShipment;
